// Step 1: the Shared Setting's name, plus the save/cancel actions that sit
// alongside it.

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, TextField } from '@decisiv/ui-components';
import { P } from '@decisiv/ui-components/lib/components/Typography';
import { t, Trans } from '@lingui/macro';

import {
  DesignSection,
  DesignSectionHead,
  FormActions,
  NameFieldCell,
  StepBadge,
  StepHeading,
  StepIntro,
  TitleActionsRow,
} from '../style';

const BasicInformation = ({
  name,
  nameError = '',
  onNameChange,
  editing = false,
  saveDisabled = false,
  onSave,
  onCancel,
}) => (
  <DesignSection>
    <DesignSectionHead>
      <StepHeading>
        <StepBadge>1</StepBadge>
        <Trans>Basic Information</Trans>
      </StepHeading>
      <StepIntro>
        <Trans>
          Give this Shared Setting a clear, recognizable name. You&apos;ll see
          it in the SRM list once two or more integrations are linked.
        </Trans>
      </StepIntro>
    </DesignSectionHead>
    <div>
      <TitleActionsRow>
        <NameFieldCell>
          <TextField
            label={t`Name`}
            name="shared-setting-name"
            required
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            errorMessage={nameError}
          />
        </NameFieldCell>
        <FormActions>
          <Button text={t`Cancel`} kind="secondary" onClick={onCancel} />
          <Button
            text={editing ? t`Save Changes` : t`Create`}
            disabled={saveDisabled}
            onClick={onSave}
          />
        </FormActions>
      </TitleActionsRow>
      {name.trim().length > 0 && !nameError && (
        <P size="small" shade={1} marginTop={0.5}>
          <Trans>
            Will appear as <strong>{name.trim()}</strong> in the Shared Settings
            list.
          </Trans>
        </P>
      )}
    </div>
  </DesignSection>
);

BasicInformation.propTypes = {
  name: PropTypes.string.isRequired,
  nameError: PropTypes.string,
  onNameChange: PropTypes.func.isRequired,
  editing: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default memo(BasicInformation);
